import React from 'react';
import Header2 from '../../Layout/Header2';
import CollapsibleSection from './Acord';
import "./accodi.css";

export default function Accordins() {
  const sections = [
    {
      title: 'How are my photos handled after the training process?',
      content: 'After the training process, we prioritize your privacy by promptly deleting all uploaded photos immediately.',
    },
    {
      title: 'Who has ownership of the ai pictures?',
      content: 'This is the content .',
    },
    {
      title: 'What type of photos are suitable for upload?',
      content: 'This is the content .',
    },
    {
      title: 'Where exactly is my data stored?',
      content: 'This is the content .',
    },
    {
      title: 'Is it possible to obtain a refund?',
      content: 'This is the content .',
    },
    {
      title: 'Which photo formats are compatible for upload?',
      content: 'This is the content .',
    },
    {
      title: 'Is the payment process secure?',
      content: 'This is the content .',
    },
    {
      title: 'Is it possible to receive an invoice?',
      content: 'This is the content .',
    },
    {
      title: 'Am I allowed to utilize my photos in any location or context?',
      content: 'This is the content .',
    },
    {
      title: 'What is the estimated processing time for training a model?',
      content: 'This is the content .',
    },
    {
      title: 'What if the generated photos dont perfectly resemble me?',
      content: 'This is the content .',
    },
    // ... Repeat for sections 3, 4, and 5
  ];
  return (
    <>
      <Header2 />
      <section id="main" className="section bg-gradient-new pricing">
        <div className="container ">
          <div className="col-lg-12">
            <div className="text-center">
              <p className="whychoose">Frequently asked questions</p>
            </div>
          </div>
          <div className='row justify-content-center'>
            <div className="col-md-10">
              <CollapsibleSection sections={sections} />
            </div>
          </div>
        </div>
      </section>
    </>
  )
}
